import { useState } from "react";
import "./OperatorRemarksCard.css";

function OperatorRemarksCard({ remarks, onRemarkClick }) {
  const [isCollapsed, setIsCollapsed] = useState(false);

  return (
    <aside
      className={`operator-remarks-card${
        isCollapsed ? " operator-remarks-card--collapsed" : ""
      }`}
      aria-label={isCollapsed ? "Uwagi operatora" : undefined}
      aria-labelledby={isCollapsed ? undefined : "operator-remarks-title"}
    >
      {isCollapsed ? (
        <button
          type="button"
          className="operator-remarks-card__collapsed-trigger"
          onClick={() => setIsCollapsed(false)}
          aria-expanded="false"
          aria-label={`Rozwiń kartę uwag operatora. Liczba uwag: ${remarks.length}`}
          title="Rozwiń kartę uwag"
        >
          <i
            className="bi bi-exclamation-triangle-fill"
            aria-hidden="true"
          />
          <span className="operator-remarks-card__collapsed-count">
            {remarks.length}
          </span>
          <span className="operator-remarks-card__collapsed-label">Uwagi</span>
          <i className="bi bi-chevron-left" aria-hidden="true" />
        </button>
      ) : (
        <>
          <button
            type="button"
            className="operator-remarks-card__toggle"
            onClick={() => setIsCollapsed(true)}
            aria-expanded="true"
            aria-label="Zwiń kartę uwag operatora"
            title="Zwiń kartę uwag"
          >
            <i className="bi bi-chevron-right" aria-hidden="true" />
          </button>

          <div className="operator-remarks-card__header">
            <i
              className="bi bi-exclamation-triangle-fill"
              aria-hidden="true"
            />
            <div>
              <h3 id="operator-remarks-title">Uwagi operatora</h3>
              <span>Liczba uwag do poprawy - {remarks.length}</span>
            </div>
          </div>

          {remarks.length > 0 ? (
            <ul className="operator-remarks-card__list">
              {remarks.map((remark) => (
                <li key={`${remark.step}-${remark.id}`}>
                  <button
                    type="button"
                    onClick={() => onRemarkClick(remark)}
                    title="Przejdź do uwagi"
                    aria-label={`Przejdź do uwagi: ${remark.location}`}
                  >
                    <span className="operator-remarks-card__location">
                      Krok {remark.step}: {remark.location}
                    </span>
                    <span className="operator-remarks-card__text">
                      {remark.text}
                    </span>
                    <span className="operator-remarks-card__action">
                      Przejdź do uwagi
                      <i className="bi bi-arrow-right" aria-hidden="true" />
                    </span>
                  </button>
                </li>
              ))}
            </ul>
          ) : (
            <p className="operator-remarks-card__empty">
              Brak aktywnych uwag operatora.
            </p>
          )}
        </>
      )}
    </aside>
  );
}

export default OperatorRemarksCard;
